import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { Role } from '../../api/types';

export type AuthUser = {
  telegramId: string;
  first_name: string;
  last_name: string;
  username?: string;
  photo_url?: string;
  role: Role;
  hasClubKey: boolean;
};

type AuthState = {
  user: AuthUser | null;
  isAuthenticated: boolean;
  authError: string | null;
};

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  authError: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSession(state, action: PayloadAction<{ user: AuthUser }>) {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.authError = null;
    },
    setAuthError(state, action: PayloadAction<string>) {
      state.authError = action.payload;
    },
    setHasClubKey(state, action: PayloadAction<boolean>) {
      if (state.user) {
        state.user.hasClubKey = action.payload;
      }
    },
    clearSession(state) {
      state.user = null;
      state.isAuthenticated = false;
      state.authError = null;
    },
  },
});

export const authReducer = authSlice.reducer;
export const authActions = authSlice.actions;
